export const getSectionOutsideWallsThicknessDetails = (): string =>
  'Valeur de <b>"Épaisseur de voiles exposés en superstructure"</b> défini dans les propriétés de la cage';
